import {styled, Typography, Box, Button} from '@mui/material'
import {useI18n} from 'store/Store'
import {getAvailableLanaguages} from 'localization/i18n'
import FormSelect from 'components/Control/Form/FormSelect'
import FormDatePicker from 'components/Control/Form/FormDatePicker'
import useDownloadFilmedDates from 'logic/Reports/useDownloadFilmedDates'
import DownloadIcon from '@mui/icons-material/Download'

const FilmedDates = () => {
    const {i18n} = useI18n()

    const {getDownloadUrl, filmedDates, control, errors, formValues} =
        useDownloadFilmedDates()

    return (
        <Container>
            <ContentWrapper>
                <Typography variant="h6" gutterBottom>
                    {i18n.t('dashboard.selectFilmedDate')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{mb: 4}}>
                    {i18n.t('dashboard.filmedDateDescription')}
                </Typography>

                <FormContainer>
                    <FormDatePicker
                        fullWidth
                        name="filmedDate"
                        label={i18n.t(`dashboard.filmedDate`)}
                        control={control}
                        error={errors.filmedDate}
                        valueFormat="YYYY-MM-DD"
                        allowedDates={filmedDates}
                    />

                    <FormSelect
                        fullWidth
                        itemsName="dashboard"
                        optionsName="languages"
                        name="language"
                        label={i18n.t(`dashboard.language`)}
                        options={getAvailableLanaguages()}
                        control={control}
                        error={errors.language}
                    />
                </FormContainer>

                <ButtonContainer>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<DownloadIcon />}
                        href={getDownloadUrl()}
                        disabled={!formValues.filmedDate}>
                        {i18n.t('dashboard.download')}
                    </Button>
                </ButtonContainer>
            </ContentWrapper>
        </Container>
    )
}

export default FilmedDates

const Container = styled(Box)`
    display: flex;
    width: 100%;
`

const ContentWrapper = styled(Box)`
    width: 100%;
    max-width: 700px;
    padding: ${({theme}) => theme.spacing(2, 3)};

    ${({theme}) => theme.breakpoints.down('sm')} {
        padding: ${({theme}) => theme.spacing(2)};
    }
`

const FormContainer = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({theme}) => theme.spacing(3)};
    margin-bottom: ${({theme}) => theme.spacing(4)};

    ${({theme}) => theme.breakpoints.down('sm')} {
        grid-template-columns: 1fr;
        gap: ${({theme}) => theme.spacing(2.5)};
    }
`

const ButtonContainer = styled(Box)`
    display: flex;
    justify-content: center;
`
